import { render, staticRenderFns } from "./table-products.vue?vue&type=template&id=01537807&scoped=true&"
import script from "./table-products.vue?vue&type=script&lang=js&"
export * from "./table-products.vue?vue&type=script&lang=js&"
import style0 from "./table-products.vue?vue&type=style&index=0&id=01537807&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01537807",
  null
  
)

export default component.exports